
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { concat, join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { TextButton } from "../Components/Button.js";
import Arrow_Left_1 from "../../public/assets/icons/Arrow_Left_1.svg";
import { singleton as singleton_1, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { singleton, empty, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { TextValue } from "../Components/Text.js";

export function DetailViewHeader(props) {
    let elems_6, elems, Label, matchValue, elems_4, elems_2, elems_1, elems_3, elems_5;
    const t = useTranslation()[0];
    return reactElement("div", createObj(singleton_1((elems_6 = [reactElement("div", createObj(ofArray([["className", join(" ", ["mb-3.5"])], (elems = [createElement(TextButton, (Label = ((matchValue = props.CustomBackButtonLabel, (matchValue == null) ? t("general.overview") : matchValue)), {
        ComponentState: "enabled",
        Icon: Arrow_Left_1(),
        Label: Label,
        OnClick: props.OnBack,
        TestId: "back-to-overview-button",
        Variant: "default",
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-between", "items-center"])], (elems_4 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "gap-3"])], (elems_2 = [reactElement("div", {
        className: join(" ", ["font-bold", "text-4xl", "text-black"]),
        children: props.Title,
        "data-test-id": concat("tool-", props.Title, ..."-header-test-id"),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row"])], (elems_1 = toList(delay(() => props.Badges)), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-5"])], (elems_3 = toList(delay(() => {
        let matchValue_1, onDelete;
        return append((matchValue_1 = props.OnDelete, (matchValue_1 == null) ? (empty()) : ((onDelete = matchValue_1, singleton(createElement(TextButton, {
            ComponentState: "enabled",
            Label: t("general.remove"),
            OnClick: onDelete,
            TestId: "delete-button",
            Variant: "redButton",
        }))))), delay(() => {
            let matchValue_2, onDuplicate;
            return append((matchValue_2 = props.OnDuplicate, (matchValue_2 == null) ? (empty()) : ((onDuplicate = matchValue_2, singleton(createElement(TextButton, {
                ComponentState: "enabled",
                Label: t("general.duplicate"),
                OnClick: onDuplicate,
                TestId: "duplicate-button",
                Variant: "default",
            }))))), delay(() => {
                const matchValue_3 = props.OnEdit;
                if (matchValue_3 == null) {
                    return empty();
                }
                else {
                    const onEdit = matchValue_3;
                    return singleton(createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: t("general.edit"),
                        OnClick: onEdit,
                        TestId: "edit-button",
                        Variant: "default",
                    }));
                }
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["mb-8", "text-sm"])], (elems_5 = toList(delay(() => {
        const matchValue_4 = props.SubTitle;
        if (matchValue_4 == null) {
            return empty();
        }
        else {
            return singleton(createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: matchValue_4,
            }));
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))]))));
}

